import axiosInstance from '../helpers/axiosInstance'

const base = warehouseId => `${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouseId}/found-stock`

export const fetchFoundStock = async (warehouseId, params = {}) => {
  const res = await axiosInstance.get(base(warehouseId), { params })
  return res.data
}

// The Locations hub badge only wants the unsettled total, and its own page is gated on a different
// grant — so a Pundit 401 here is routine. `skipAuthRefresh` (honoured by axios-auth-refresh) keeps
// that denial from costing a refresh_token round-trip, and a failed refresh from forcing a logout.
export const fetchFoundStockQueueTotal = async warehouseId => {
  const res = await axiosInstance.get(base(warehouseId), { params: { page: 1, per_page: 1 }, skipAuthRefresh: true })
  return res.data
}

export const fetchFoundStockAwaitingPutAway = async warehouseId => {
  const res = await axiosInstance.get(`${base(warehouseId)}/awaiting-put-away`)
  return res.data
}

export const fetchFoundStockDeclaration = async (warehouseId, declarationId) => {
  const res = await axiosInstance.get(`${base(warehouseId)}/${declarationId}`)
  return res.data
}

export const matchFoundStock = async (warehouseId, stockUnitIds) => {
  const res = await axiosInstance.post(`${base(warehouseId)}/match`, { stock_unit_ids: stockUnitIds })
  return res.data
}

export const inboundFoundStock = async (warehouseId, stockUnitIds) => {
  const res = await axiosInstance.post(`${base(warehouseId)}/inbound`, { stock_unit_ids: stockUnitIds })
  return res.data
}

// `reason` travels in the request only; the server never echoes it and the UI never renders it.
export const correctFoundStockDeclaration = async (warehouseId, declarationId, { request_id, quantity_after, reason }) => {
  const res = await axiosInstance.post(`${base(warehouseId)}/${declarationId}/corrections`, { request_id, quantity_after, reason })
  return res.data
}
